export default __webpack_public_path__ + "6ff326e807012dc8762f94fbdba0e344.svg";